import { render, staticRenderFns } from "./SideBarPc.vue?vue&type=template&id=e5b749ec&scoped=true&"
import script from "./SideBarPc.vue?vue&type=script&lang=ts&"
export * from "./SideBarPc.vue?vue&type=script&lang=ts&"
import style0 from "./SideBarPc.vue?vue&type=style&index=0&id=e5b749ec&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b749ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VLayout,VSpacer})
